
var gg;

  var WBO_a;
  var wbo_js = true;

  (function(url, position, callback){
      url = url || 'https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js';
      position = position || 0;
      
      if (!window.$) {
          var head = document.getElementsByTagName('head')[0];
          var script = document.createElement("script");
          script.src = url;
          script.type = 'text/javascript';
          head.appendChild(script);
          head.insertBefore(script,head.childNodes[position]);

          script.onload = function(){
              if(typeof callback == 'function') {
                  callback($);
              }
          };
      } else {
          if(typeof callback == 'function') {
            WBO_a = $.noConflict();
 
            callback(WBO_a);
          }
      }
    }('https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js', 5, function(WBO_a){

    WBO_a.getScript("https://unpkg.com/bootstrap-table@1.22.1/dist/bootstrap-table.min.js", function() {
        
        if(WBO_a('#wbo_table').length){
          gg = WBO_a;
          init_wbo(WBO_a);  
          
        }
        
      });
    
    }));

  var $wbo_table;
  var wbo_addtocart_text = wbo_addtocart_text;
  var variant_hide_js = variant_hide_text;
  var variant_view_js = variant_view_text;
  var wbo_max_qty_message_js = wbo_max_qty_message;

 init_wbo = function(WBO_a){
   console.log("customfile");

    WBO_a(".wbo_filters_list ul li:nth-child(2)").addClass("active");
    
    get_products('',false,1,"manual",false,WBO_a);
    

    // hide filter on click outside
    WBO_a(document).on("click", "html", function() {
      WBO_a("#wbo_toolbar_filter").removeClass("wbo_active");
    })
    .on("click", "#wbo_toolbar_filter", function(e){
      e.stopPropagation();
      WBO_a(this).toggleClass("wbo_active");
    })
    .on('click', '#wbo_toolbar_filter .wbo_filters_list', function(e) {
      e.stopPropagation();
    });
    
    // filter function
    WBO_a(document).on("click", "#wbo_toolbar_filter .wbo_filters_list ul li:not(.active):not(.filter_text)", function(e){

      var collection_handle = WBO_a(this).data("collection-handle");

      // add active class for selected collection
      WBO_a(".wbo_filters_list ul li").removeClass("active");
      WBO_a(this).addClass("active");
      WBO_a("#wbo_table").addClass("wbo_hide");

      WBO_a(".wbo_loader").show();
      
      get_products(collection_handle, true,1,"manual",false,WBO_a);
      
    });

    // get variants
    WBO_a(document).on("click", ".wbo_view_variants", function(){

      var th = WBO_a(this);

      var total_variants = th.data('total-variants');
      
      var p_id = th.data('id');
      console.log(p_id);

      if(WBO_a("[data-product-id="+ p_id +"]").parents("tr").is(':visible')){
        
        var button_show_text = variant_view_text.replace(/{COUNT}/gi, total_variants);
            
        th.html(button_show_text);
        
        WBO_a("[data-product-id="+ p_id +"]").parents("tr").hide();  
      }else{
        th.html(variant_hide_text.replace(/{COUNT}/gi, total_variants));
        WBO_a("[data-product-id="+ p_id +"]").parents("tr").show();
      }
      
    })

    // add to cart
    WBO_a(document).on("click", ".wbo_add_to_cart", function (params) {
      
      var th = WBO_a(this);
      var variant_id = th.data('variant-id');
      var parent = th.parents(".wbo_qty_wrapper");
      var qty = parseInt(parent.find(".wbo_qty_input").val());

      var int_max_qty = parseInt(max_qty);
      // check if qty is more than allowed
      parent.find(".wbo_message").val("").show();
      if(qty > int_max_qty){
        hide_message(parent, ".wbo_error", 4000);
        
        parent.find(".wbo_message").html("<p class='wbo_error'>"+ wbo_max_qty_message_js.replace(/{QUANTITY}/gi, max_qty) +"</p>");
        return;
      }

      if(qty <= 0){
        hide_message(parent, ".wbo_error", 4000);
        parent.find(".wbo_message").html("<p class='wbo_error'>Atleast 1 quantity is required</p>");
        return;
      }
      
      var items = { 'items':[{
          "id": variant_id,
          "quantity": qty
        }]
      };

      // for loading
      var button_html = th.html();
      th.html("<div class='wbo_loader_variant'></div>");

      //console.log(items);return;
      
      var request = WBO_a.ajax({
        url: "/cart/add.js",
        method: "POST",
        contentType: 'application/json',
        data: JSON.stringify(items),
        dataType: "json",
      });
      request.done(function( cart ) {

        var previous_cart_total = Number(WBO_a(".wbo_cart_total").data("total-price"));

        var p_price = Number(th.data('price'));

        var qty = th.parents(".wbo_qty_wrapper").find(".wbo_qty_input").val();
        
        var new_total = ((previous_cart_total + (p_price * qty))/100).toFixed(2);

        var format_total_price = currency_format.replace("{{amount}}", new_total);
        
        WBO_a(".wbo_cart_total").html(format_total_price).data("total-price", new_total*100);
        
        WBO_a.getJSON( "/cart.js", function( data ) {
            
            // update total
            
            // $(".wbo_cart_total").html(format_price);
            WBO_a(".wbo_cart_item_total").html(data.item_count);

            hide_message(parent, ".wbo_success", 4000);
            
            parent.find(".wbo_message").html("<p class='wbo_success'>"+ wbo_addtocart_message.replace('{QUANTITY}', qty).replace('&lcub;QUANTITY&rcub;', qty).replace('<p>', '').replace('</p>', '') +"</p>");  
      
        });
        
      });
      request.fail(function( jqXHR, textStatus, errorThrown ) {

        console.log(jqXHR.responseText.description);

        var error_msg = WBO_a.parseJSON(jqXHR.responseText);
        
        hide_message(parent, ".wbo_error", 4000);
        parent.find(".wbo_message").html("<p class='wbo_error'>"+ error_msg.description +"</p>");  
        
      });
      
      request.always(function(){
        WBO_a(th).html("Add more");
      })
      
      
    })
    
    WBO_a(document).on("click", ".wbo_show_more", function(){

      var page_number = WBO_a(this).data("page");
      var is_search = WBO_a("#wbo_page .search-input").val();
      if(is_search != ''){
       
        get_products('', true, page_number, "", is_search,WBO_a);  
      }else{
        get_products('', true, page_number,"manual",false,WBO_a);  
      }
    });

    WBO_a(document).on("change", ".wbo_select_options", function(){
      var sort_val = WBO_a(this).val();
     
      get_products('', true, 1, sort_val,false,WBO_a);  
    });

    WBO_a(document).on("focus", ".search-input", function(){
      WBO_a(this).parent().css("width", "100%");
      WBO_a(".float-right").hide();
    });

    WBO_a(document).on("focusout", ".search-input", function(){
      if(WBO_a(this).val() == ""){
        WBO_a(this).parent().css("width", "55%");
        WBO_a(".float-right").show();  
      }
      
    });
  }

  function get_variants(th){
    var product_id = th.data("id");
    
    var tr_index = th.parents("tr").data('index');

    var button_html = th.html();

    th.html("<div class='wbo_loader_variant'></div>");

    // this code is to prevent multiple click
    var me = th;
    if ( me.data('requestRunning') ) {
      return;
    }
    me.data('requestRunning', true);
    
    var request = WBO_a.ajax({
      url: "/apps/wbo",
      method: "POST",
      data: {action: "get_variants", product_id: product_id, is_stock_show: is_stock_show},
      dataType: "json",
      crossDomain: true
    });
  
    request.done(function( data ) {

      if(typeof data.view != "undefined"){

        
     console.log("here");

        
        var v_data = data.view;

        // insert variants
        for (let i = 0; i < v_data.length; i++) {

          var variant_image_src = v_data[i].v_image;
          var product_id = v_data[i].p_id;

          // check if image available, if not, add a placeholder
          if(variant_image_src === ''){
            variant_image_src = placeholder_image;
          }
    
          variant_image = '<img class="wbo_image" src='+ variant_image_src +' alt='+ v_data[i].v_alt +'>'

          var cart_button = "<span data-product-id='"+ product_id +"' data-variant-id='"+ v_data[i].v_id +"' class='button wbo_add_to_cart'>" + wbo_addtocart_text +"</span><p class='wbo_message'></p>";

          var qty_html = "<div class='wbo_qty_wrapper variant_row variant_product_id_"+ product_id +"'><input value="+ min_qty +" class='wbo_qty_input' name='qty' type='number' max='"+ max_qty +"' min='"+ min_qty +"' step='"+ wbo_group +"' >" + cart_button + "</div>" ;

          var v_title = "<a target='_blank' href='/products/"+ v_data[i].p_handle +"?variant="+ v_data[i].v_id +"'>"+ v_data[i].v_title +"</a>"
          
          $wbo_table.bootstrapTable('insertRow', {
            index: ++tr_index,
            row: {
              id: v_data[i].v_id,
              image: variant_image,
              title: v_title,
              sku: v_data[i].v_sku,
              price: v_data[i].v_price,
              stock: v_data[i].v_stock,
              qty: qty_html
            }
          
          });

          //show only clicked variants
          WBO_a(".variant_row").parents(".product-row").hide();
          
          
          var variants_class = WBO_a("#wbo_table").find(".variant_product_id_" + product_id);
          variants_class.parents(".product-row").show();

        }
      }
      
    });

    request.always(function(){
      WBO_a("#wbo_table").find("[data-id="+ product_id +"]").html(button_html);   
      me.data('requestRunning', false);
    })
  
    request.fail(function( jqXHR, textStatus ) {
      console.log( "Request failed: " + textStatus );
    });
  }

  function get_products(collection_handle = '', is_second_time = false, page=1, sort_by = "manual", is_search = false,WBO_a){

    if(collection_handle == ''){
      collection_handle = WBO_a(".wbo_filters_list ul li.active").data("collection-handle");
    }
    
    // this code is to prevent multiple click
    var me = WBO_a("#wbo_table");

    if ( me.data('requestRunning') ) {
      return;
    }
    me.data('requestRunning', true);

    if(is_search){
      var ajax_url = "/search?view=wbo_search_data&type=product&page="+ page +"&q=" + sort_by;  
    }else
      var ajax_url = "/collections/"+ collection_handle +"?view=wbo_collection_data&page="+ page +"&sort_by=" + sort_by;
    
    var request = WBO_a.ajax({
      url: ajax_url,
      method: "GET",
      dataType: "json",
      crossDomain: true
    });
  
    request.done(function( server_data ) {

      if(typeof server_data.view != "undefined"){

        // set total cart price
        WBO_a(".wbo_cart_total").html(server_data.view.total_cart_price_with_currency);
        
        WBO_a(".wbo_cart_total").data("total-price", server_data.view.total_cart_price);

        var data = server_data.view.productItems;

        if(data.length > 1 || server_data.view.totalProductCount == 0)
          server_data.view.productItems.splice(-1);

        for (let i = 0; i < data.length; i++) {

          console.log()
          var format_price = data[i]['price'];
          var product_image = data[i]['image_src'];
          var image_alt = data[i]['image_alt'];
          var variant_count = data[i]['variant_count'];
          var variant_view_text_replace = variant_view_js.replace(/{COUNT}/gi, variant_count);

          if(typeof data[i]['discounted_price'] != "undefined"){
            var disc_price = data[i]['discounted_price'];
            var format_price = "<s class='wbo_disc_price'>" + format_price + "</s> <span class='wbo_retail_price'>" + disc_price + "</span>";
          }

          var is_variant = "";

          if(typeof data[i]['product_id'] != 'undefined'){
            var is_variant = "data-variant-product";
          }
          if(data[i]['is_available']){
            var cart_button = "<span style='background-color:"+ add_cart_button_color +"; padding:13px;  color:white; cursor: pointer;' data-price="+ data[i]['actual_price'] +" "+ is_variant +" data-product-id='"+ data[i]['id'] +"' data-variant-id='"+ data[i]['variant_id'] +"' class='button wbo_add_to_cart'>"+ wbo_addtocart_text +"</span><p class='wbo_message'></p>";  
          }else{
            var cart_button = "<span data-price="+ data[i]['actual_price'] +" "+ is_variant +" data-product-id='"+ data[i]['id'] +"' data-variant-id='"+ data[i]['variant_id'] +"' class='button button--secondary wbo_sold_out'>Sold out</span><p class='wbo_message'></p>";  
          }

          var qty_html = "<div class='wbo_qty_wrapper'><input class='wbo_qty_input' value='1' name='qty' type='number' min='1' step='"+ wbo_group +"' >" + cart_button + "</div>" ;
          
          
          data[i]['price'] = format_price;
          
          if(variant_count > 1){
              qty_html = "<span data-total-variants="+ variant_count +" class='btn button button--secondary wbo_view_variants' data-id='"+ data[i]['id'] +"'>" + variant_view_text_replace + "</span>";
          }

          data[i]['qty'] = qty_html;
          
          if(product_image === ''){
            product_image = placeholder_image;
          }

          if(image_alt === null){
            image_alt = data[i]['title'];
          }


          
          if(variant_count==1){

              data[i]['sku'] =data[i]['variant_title']; 
            

            
          }
          
          




          data[i]['image'] = "<img class='wbo_image' src='"+ product_image +"' alt='"+ image_alt +"'>"

          data[i]['title'] = "<a target='_blank' href='/products/"+data[i]['handle']+"'>"+data[i]['title']+"</a>"
          
        }

        WBO_a('#wbo_table').show();
        $wbo_table = WBO_a('#wbo_table');

        if(is_second_time){

          if(page > 1)
            $wbo_table.bootstrapTable('append', data);
          else
            $wbo_table.bootstrapTable('load', data);
          
        }else{
          
          $wbo_table.bootstrapTable({
          data: data,
          pagination: false,
          search: true,
          customSearch: "customSearch",
          searchAccentNeutralise: true,
          toolbar: "#wbo_toolbar, #wbo_toolbar_filter, #wbo_toolbar_sort",
          searchAlign: "left",
          toolbarAlign: "right",
          formatSearch: function(){
            return placeholdertext;
          },
          rowStyle: function(row, index){
              return {
                classes: "product-row"
              };
            },
          });

        }
        
      }

      if(typeof server_data.view.currentPageNumber != "undefined"){
        if(server_data.view.totalPages != server_data.view.currentPageNumber){
          // $(".wbo_show_more").show();
          var next_page = Number(server_data.view.currentPageNumber) + 1;
          WBO_a(".wbo_show_more").show().data("page", next_page);  
        }else{
          WBO_a(".wbo_show_more").hide();
        }
        
      }

      hide_variants(WBO_a)
      
    });

    request.always(function(){
      WBO_a(".wbo_loader").hide();
      

      if(WBO_a(".search-input").val() != '')
      WBO_a(".float-right").hide();
      else
      WBO_a("#wbo_page #wbo_toolbar, #wbo_page #wbo_toolbar_filter, #wbo_toolbar_sort").css("display","inline-block");
      
      WBO_a("#wbo_table").removeClass("wbo_hide");
      WBO_a(".fixed-table-toolbar").addClass("gradient");
      me.data('requestRunning', false);
    })
  
    request.fail(function( jqXHR, textStatus ) {
      console.log( "Request failed: " + textStatus );
    });
  }

  function hide_variants(WBO_a) {

    WBO_a("[data-variant-product]").each(function(){
      WBO_a(this).parents("tr").hide();
    })
    
  }

  function customSearch(data, text) {
    
    var WBO_a;
    console.log(text);
    var search_text = text + "*";

    if(text == ''){
     
      get_products('', true,1,"manual",false,gg);
    }else{
      get_products('', true, 1, search_text,true,gg);  
    }
    
    return data.filter(function (row) {
      return true;
    })
      
  }

  function hide_message(parent,target, time) {
    setTimeout(function(){
      parent.find(target).hide();
    }, time);
  }

